module.exports = __webpack_public_path__ + "static/media/fr_MIDbooklet_modelnum@2x.62b22694.png";